module.exports = __webpack_public_path__ + "img/ico_payment_cards_dark.6c43672e.svg";